<script lang="ts">
    import { getContext } from "svelte";
    import Page from "../components/Page.svelte";
    import { useLocation } from "../components/router/context";
    import Footer from "../components/Footer.svelte";

    const gigyaContext: any = getContext("gigya");
    const { navigate } = useLocation();

    $effect(() => {
        if (gigyaContext.ready && gigyaContext.loggedIn) {
            gigya.accounts.showScreenSet({
                screenSet: 'Default-ProfileUpdate',
                containerID: 'gigya-screen',
                authMode: 'popup'
            });
        } else {
            navigate('/login');
        }
    });
    
    // export const env = typeof Deno !== 'undefined' ? Deno.env : typeof  Netlify !== 'undefined' ? Netlify.env : {};
    
</script>

{#snippet footerSlot()}
    <Footer title="Learn more about Customer Data Cloud<br>and what it brings to SAP customers" url={"https://cdc.dcom.zon.cx"} btnTitle="Learn More"  />
{/snippet}

<Page footer={footerSlot}>
    <article class="container m-auto flex flex-col items-center justify-center">
        <img src="/img/league-logo.png" alt="league logo" class="h-40 object-contain mb-8" />
        <div id="gigya-screen" class="w-full"></div>
    </article>
</Page>

<style>
</style>